const tabs = document.getElementsByClassName('tabs');
const guideTabs = document.getElementsByClassName('guideTab');
const tabTargets = document.getElementsByClassName('tabTarget');

if (tabs != "") {
	for (let i = 0; i < guideTabs.length; i++) {

		let btn = guideTabs[i].children;
		btn[0].addEventListener('click', function (e) {

			//リセット
			for (let j = 0; j < guideTabs.length; j++) {
				guideTabs[j].classList.remove('is-active');
				tabTargets[j].style.display = "none";
			}

			//表示
			let index = Array.prototype.indexOf.call(guideTabs, e.target.parentNode);
			guideTabs[index].classList.add('is-active');
			tabTargets[index].style.display = "block";
		});
	}

	//読み込み時
	guideTabs[0].classList.add('is-active');
	tabTargets[0].style.display = "block";
}
